import styled from 'styled-components';

import { SmallText } from '../styles';

export const TitleText = styled(SmallText)`
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes.big};
`;

export const CenteredContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-align: center;
`;
